import { User } from '../../../types/models/user/user.types';
import { AUTH_ENDPOINTS } from '../../../utils/api/endpoints/authEndpoints';

export const CHECK_TOKEN_QUERY_KEY = 'CHECK_TOKEN';

export const queryCheckToken = async () => {
  const response = await AUTH_ENDPOINTS.checkToken();

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    throw error;
  }

  return json as User;
};
